import { createUserManager } from "redux-oidc";

const AUTHORITY = window.__AUTH_SERVER__;

if (typeof AUTHORITY !== "string" || !AUTHORITY.length) {
  throw Error(
    "Missing injected value '__AUTH_SERVER__'. Application cannot start"
  );
}

const baseUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ""
}`;

const config = {
  client_id: "Fees.Web",
  redirect_uri: `${baseUrl}/signin-oidc`,
  response_type: "id_token token",
  scope:
    "openid profile user.profile user.entity user.organization user.office SMAppServices",
  authority: AUTHORITY,
  post_logout_redirect_uri: baseUrl,
  silent_redirect_uri: `${baseUrl}/silent_renew.html`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true
};

const userManager = createUserManager(config);

export default userManager;
